/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { useIntl } from 'react-intl'

import { CuiCodeEditor } from '@modules/cui/CodeEditor'

type Props = {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

const ApiConsoleBody: React.FunctionComponent<Props> = ({ value, onChange, disabled }) => {
  const { formatMessage } = useIntl()

  return (
    <CuiCodeEditor
      aria-label={formatMessage({
        id: 'apiConsole.bodyLabel',
        defaultMessage: 'Body',
      })}
      height='192px' // 12 lines x 16px
      language='json'
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  )
}

export default ApiConsoleBody
